"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _path, _path2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 9h2v8h-2V9zm-2 0H9v8h2V9z"
  })), _path2 || (_path2 = /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.49 5c-.027-.577-.127-1.255-.52-1.819C14.364 2.315 13.321 2 11.997 2c-1.353 0-2.42.306-3.017 1.195-.276.411-.386.859-.436 1.25a5.966 5.966 0 00-.04.555H3v2h2v14h14V7h2V5h-5.51zm-4.96-.303c-.013.093-.02.193-.024.303h2.978c-.023-.371-.074-.559-.155-.675C13.284 4.261 13.077 4 12 4c-1.146 0-1.33.27-1.358.311-.036.054-.083.161-.112.386zM17 7H7v12h10V7z"
  }))];
};

exports.default = _default;